import * as types from './types'
import Vue from 'vue'

export default {
  [types.SET_LIST] (state, payload) {
    state.list = payload
  },
  [types.SET_LIST_LOADING] (state, payload) {
    state.listLoading = payload
  },
  [types.SET_LIST_RENDER] (state, payload) {
    state.listRender = payload
  },
  [types.SET] (state, payload) {
    state.record = payload
  },
  [types.SET_RECORD_LOADING] (state, payload) {
    state.recordLoading = payload
  },
  [types.TOTAL_COUNT] (state, payload) {
    state.totalCount = payload
  }
}
